import { useState } from 'react';
import { Navigate, Link, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../providers/UserProvider';
import { AuthLayout } from '../components/AuthLayout';
import * as authRepository from '../repositories/authRepository';

export default function LoginPage() {
  const { isLoggedIn, login } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = useState('');
  const from = (location.state as { from?: { pathname?: string; search?: string } } | null)?.from;
  const redirectTo = from?.pathname ? `${from.pathname}${from.search || ''}` : '/tldr';

  if (isLoggedIn) return <Navigate to={redirectTo} replace />;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage('');
    const form = new FormData(e.currentTarget);
    try {
      const data = await authRepository.login(
        form.get('usernameOrEmail') as string,
        form.get('password') as string,
      );
      login(data);
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setMessage((err as Error).message || 'Sign-in failed');
    }
  };

  return (
    <AuthLayout
      message={message}
      isError={!!message}
      footer={<><Link to="/signup">Sign up</Link><Link to="/forgot-password">Forgot password?</Link></>}
    >
      <form onSubmit={handleSubmit} className="auth-form">
        <label>
          <span>Username or email</span>
          <input type="text" name="usernameOrEmail" autoComplete="username" required />
        </label>
        <label>
          <span>Password</span>
          <input type="password" name="password" autoComplete="current-password" required />
        </label>
        <button type="submit" className="primary-button">Log in</button>
      </form>
    </AuthLayout>
  );
}
